import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {environment} from '../../../environments/environment';
import {ComponentBase} from '../../core/entities/component-base';


@Component({
  selector: 'app-auth-check',
  templateUrl: './auth-check.component.html',
  styleUrls: ['./auth-check.component.css']
})
export class AuthCheckComponent extends ComponentBase implements OnInit {

  constructor(private _router: Router, private _authService: AuthService) { super(); }

  ngOnInit() {
    this._authService.isLoggedIn().subscribe(check => {
      if (check) {
        this._router.navigateByUrl(environment.homePage);
      }else {
        this._router.navigateByUrl(environment.loginPage);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-check/auth-check.component.ts